import styled from '@emotion/styled'
import { InputHTMLAttributes } from 'react'
import * as React from 'react'

export type RadioInputProps = React.HTMLAttributes<HTMLInputElement> & {
  isError?: boolean
}

const StyledRadioInput = styled.input<RadioInputProps>`
  cursor: pointer;

  &[type='radio']:after {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    top: 0px;
    left: 0px;
    position: relative;
    content: '';
    display: inline-block;
    visibility: visible;
    background: var(--White);
    border: 2px solid var(--White);
    box-shadow: 0px 0px 0px 1.5px var(--Red-Dark);
  }

  &[type='radio']:checked:after {
    background: var(--Red-Dark);
    box-shadow: 0px 0px 0px 1.5px var(--Red-Dark);
  }

  &[type='radio']:disabled:after {
    background: var(--White90);
    box-shadow: 0px 0px 0px 1px var(--White90);
  }

  &[type='radio']:checked:disabled:after {
    background: var(--White90);
    box-shadow: 0px 0px 0px 1px var(--White90);
  }
`

export const RadioInput = (props: InputHTMLAttributes<HTMLInputElement>) => (
  <StyledRadioInput {...props} type="radio" />
)
